import React, { useContext } from 'react';
import { FC, ReactNode } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import UserContext from 'src/contexts/UserContext';

interface AuthGuardProps {
  children?: ReactNode;
}

export const DummyBusinessPricingGuard: FC<AuthGuardProps> = ({ children }) => {
  const userContext = useContext(UserContext).userData;

  if (userContext.companyID != null && userContext.baseCurrency != null) {
    return <Redirect to="/app/pricing" />;
  }

  return <>{children}</>;
};

export const DummyBusinessInitializationGuard: FC<AuthGuardProps> = ({
  children,
}) => {
  const userContext = useContext(UserContext).userData;
  // dummy businesses created for invited users on seat plan do not have a base currency
  if (userContext.companyID != null && userContext.baseCurrency == null) {
    return <Redirect to="/app/create-business" />;
  }

  return <>{children}</>;
};

DummyBusinessPricingGuard.propTypes = {
  children: PropTypes.node,
};
